/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_Context_Too_SmallInputs */



/**
* | output |
* | --- |
* | "Context below 128,000" |
*
* @param {Private_Models_Connection_Context_Too_SmallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_context_too_small = /** @type {((inputs?: Private_Models_Connection_Context_Too_SmallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Context_Too_SmallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontext unter 128.000")
	return /** @type {LocalizedString} */ ("Context below 128,000")
});